export default __webpack_public_path__ + "static/media/feature-gifts.a8f9f3aa.jpg";